import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const opencage = defineConnector({
  identifier: "opencage",
  name: "OpenCage",
  tagLine: "Geocoding and reverse geocoding",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.opencagedata\\.com/.*",
  auth: (app) => queryAuth([{ name: "key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "Find your API key in the Geocoding section of your [OpenCage account dashboard](https://opencagedata.com/api).",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "OpenCage API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.opencagedata.com/geocode/v1/json?q=Berlin",
  },
});
